import { Link } from "react-router-dom";

function Footer({ onBookDemo }) {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <div className="footer-logo">QAP Financials</div>
          <p className="footer-tagline">
            Consolidated financial reporting for modern, multi-entity finance
            teams — connected to QuickBooks, exportable to Excel, always
            audit-ready.
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-col">
            <h4>Product</h4>
            <a href="#why">Why QAP</a>
            <a href="#how">How It Works</a>
            <Link to="/signup">Sign Up</Link>
            <button onClick={onBookDemo}>Book Demo</button>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <a href="#about">About Us</a>
            <a href="#contact">Contact</a>
          </div>

          <div className="footer-col">
            <h4>Legal</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/eula">Terms &amp; EULA</Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {year} QAP Financials. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
